import type React from "react";

// import { Link } from "@heroui/link";
// import { Trans, useTranslation } from "react-i18next";

// import { Navbar } from "@/components/navbar";
import { SidebarLayout } from "@/components/Sidebar/SidebarLayout";
import { SidebarProvider } from "@/components/Sidebar/SidebarContext";

export default function DefaultLayout({ children }: { children: React.ReactNode }) {
  return (
    <SidebarProvider>
      <div className="relative flex flex-col w-full" style={{ height: "var(--app-height)" }}>
        <main className="w-full flex-grow m-0">
          <SidebarLayout>
            {/* <Navbar /> */}
            {children}
          </SidebarLayout>
        </main>
        {/*<footer className="w-full flex items-center justify-center py-3">
         <Link
          isExternal
          className="flex items-center gap-1 text-current"
          href="https://webuild-ai.com"
          title={t("heroui-com-homepage")}
        >
           <span className="text-default-600">
            <Trans ns="base">powered-by</Trans>
          </span>
          <p className="text-primary">WeBuild AI™</p>
        </Link>
      </footer> */}
      </div>
    </SidebarProvider>
  );
}
